import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import React, { useState, useEffect } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { CheckCircle, Eye, EyeOff } from "react-feather";
import api from "../api";
import glogo from "../../feature/glogo.png";

function SellerRegister() {
    const baseUrl = process.env.REACT_APP_BASE_URL;

    const [errorMsg, seterrorMsg] = useState("");
    const [successMsg, setsuccessMsg] = useState("");
    const [loading, setLoading] = useState(false);

    const [ShowEmail, setShowEmail] = useState(false);
    const [ShowSuccessPage, setShowSuccessPage] = useState(false);

    const [emailError, setEmailError] = useState("");
    const [FnameError, setFnameError] = useState(false);
    const [UnameError, setUnameError] = useState(false);
    const [PasswordError, setPasswordError] = useState(false);

    const [showPassword, setShowPassword] = useState(false);
    const [affiliateId, setAffiliateId] = useState("");

    const [registerFormData, setRegisterFormData] = useState({
        first_name: "",
        username: "",
        email: "",
        password: "",
        email_code: "",
    });

    const location = useLocation();

    const inputHandler = (event) => {
        setRegisterFormData({
            ...registerFormData,
            [event.target.name]: event.target.value,
        });
    };

    // Prefill business name
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const shopnameFromUrl = params.get("shopname");

        if (shopnameFromUrl && !registerFormData.username) {
            setRegisterFormData((prev) => ({
                ...prev,
                username: shopnameFromUrl.toLowerCase(),
            }));
        }
    }, [location.search]);

    // Affiliate tracking
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const ref = params.get("ref");

        if (ref) {
            setAffiliateId(ref);
        }
    }, [location]);

    const validateEmail = (email) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (email && !emailPattern.test(email)) {
            setEmailError("Invalid email format.");
        } else {
            setEmailError("");
        }
    };

    const submitHandler = async () => {
        setLoading(true);

        const formData = new FormData();

        formData.append("first_name", registerFormData.first_name);
        formData.append("shopname", registerFormData.username);
        formData.append(
            "username",
            registerFormData.username.replace(/\s+/g, "").toLowerCase()
        );
        formData.append("email", registerFormData.email);
        formData.append("password", registerFormData.password);

        if (affiliateId) {
            formData.append("affiliate_id", affiliateId);
        }

        try {
            const response = await api.post(
                baseUrl + "/vendor/register/",
                formData
            );

            if (response.data.bool === false) {
                seterrorMsg(response.data.msg);
                setLoading(false);
                return;
            }

            setRegisterFormData({
                first_name: "",
                username: "",
                email: "",
                password: "",
                email_code: "",
            });

            setLoading(false);
            setShowEmail(false);
            setShowSuccessPage(true);
            setsuccessMsg(response.data.msg);

        } catch (error) {
            seterrorMsg(
                error.response?.data?.msg ||
                "An error occurred. Kindly try again."
            );
            setLoading(false);
        }
    };

    const sendVerificationCode = async () => {
        seterrorMsg("");

        if (registerFormData.first_name.length < 2) {
            setFnameError(true);
            return;
        } else {
            setFnameError(false);
        }

        if (registerFormData.username.length < 2) {
            setUnameError(true);
            return;
        } else {
            setUnameError(false);
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (
            registerFormData.email !== "" &&
            !emailPattern.test(registerFormData.email)
        ) {
            setEmailError("Invalid email format.");
            return;
        } else {
            setEmailError("");
        }

        if (registerFormData.password.length < 7) {
            setPasswordError(true);
            return;
        } else {
            setPasswordError(false);
        }

        setLoading(true);

        try {
            const response = await api.post(
                baseUrl + "/send-verification-email/",
                {
                    email: registerFormData.email,
                    username: registerFormData.username,
                }
            );

            if (response.data.success === true) {
                setShowEmail(true);
                seterrorMsg("");
            } else {
                seterrorMsg(response.data.message);
            }
        } catch {
            seterrorMsg("Failed to send verification code.");
        }

        setLoading(false);
    };

    const verifyCode = async () => {
        if (registerFormData.email_code.length < 3) {
            seterrorMsg("Invalid verification code.");
            return;
        }

        try {
            const response = await api.post(
                baseUrl + "/verify-email-code/",
                {
                    email: registerFormData.email,
                    code: registerFormData.email_code,
                }
            );

            if (response.data.success === true) {
                await submitHandler();
            } else {
                seterrorMsg(response.data.message);
            }
        } catch (error) {
            seterrorMsg(
                error.response?.data?.message ||
                "Verification failed."
            );
        }
    };

    // GOOGLE SIGNUP
    const googleRegister = useGoogleLogin({
        flow: "implicit",

        onSuccess: async (tokenResponse) => {
            try {
                const response = await api.post(
                    baseUrl + "/vendor/google-auth/",
                    {
                        token: tokenResponse.access_token,
                        affiliate_id: affiliateId,
                    }
                );

                if (response.data.bool) {
                    const {
                        access_token,
                        refresh_token,
                        user,
                        shop,
                        id,
                        new_user,
                        setup_completed,
                    } = response.data;

                    localStorage.setItem("access_token", access_token);
                    localStorage.setItem("refresh_token", refresh_token);
                    localStorage.setItem("vendor_username", user);
                    localStorage.setItem("vendor_shopname", shop);
                    localStorage.setItem("vendor_id", id);
                    localStorage.setItem("vendor_login", true);

                    if (new_user || !setup_completed) {
                        window.location.href = "/seller/setup";
                    } else {
                        window.location.href = "/seller/dashboard";
                    }
                }
            } catch {
                seterrorMsg("Google signup failed.");
            }
        },

        onError: () => {
            seterrorMsg("Google signup failed.");
        },
    });

    return (
        <>
            <Helmet>
                <title>Create account</title>
                <meta name="description" content="Create account" />
            </Helmet>

            <section className="container mtopcon normal-mt-sctn">
                <div className="row">
                    <div className="col-12 col-lg-4 reglogincon">
                        <div className="card shadow-none">
                            <div className="card-body">

                                {!ShowSuccessPage && (
                                    <h2 className="mb-3 text-center">
                                        <b>Create an account</b>
                                    </h2>
                                )}

                                {!ShowEmail && !ShowSuccessPage && (
                                    <>
                                        <div className="row">
                                            <div className="col-6 mt-2">
                                                <label className="form-label font9 grey-text mb-0">
                                                    Business Name
                                                </label>

                                                <input
                                                    type="text"
                                                    name="username"
                                                    value={registerFormData.username}
                                                    onChange={inputHandler}
                                                    className="form-control font9"
                                                />

                                                {UnameError && (
                                                    <small className="text-danger">
                                                        Confirm business name.
                                                    </small>
                                                )}
                                            </div>

                                            <div className="col-6 mt-2">
                                                <label className="form-label font9 grey-text mb-0">
                                                    Owner Name
                                                </label>

                                                <input
                                                    type="text"
                                                    name="first_name"
                                                    value={registerFormData.first_name}
                                                    onChange={inputHandler}
                                                    className="form-control font9"
                                                />

                                                {FnameError && (
                                                    <small className="text-danger">
                                                        Confirm owner name.
                                                    </small>
                                                )}
                                            </div>
                                        </div>

                                        <div className="mt-2">
                                            <label className="form-label font9 grey-text mb-0">
                                                Email
                                            </label>

                                            <input
                                                type="email"
                                                name="email"
                                                value={registerFormData.email}
                                                onChange={inputHandler}
                                                onBlur={(e) =>
                                                    validateEmail(e.target.value)
                                                }
                                                className="form-control font9"
                                            />

                                            {emailError && (
                                                <small className="text-danger">
                                                    {emailError}
                                                </small>
                                            )}
                                        </div>

                                        <div className="mt-2">
                                            <label className="form-label font9 grey-text mb-0">
                                                Password
                                            </label>

                                            <div className="input-group">
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    name="password"
                                                    placeholder="At least 7 characters"
                                                    value={registerFormData.password}
                                                    onChange={inputHandler}
                                                    className="form-control font9"
                                                />

                                                <button
                                                    type="button"
                                                    className="btn btn-outline-grey"
                                                    onClick={() =>
                                                        setShowPassword(!showPassword)
                                                    }
                                                >
                                                    {showPassword ? (
                                                        <EyeOff size={18} />
                                                    ) : (
                                                        <Eye size={18} />
                                                    )}
                                                </button>
                                            </div>

                                            {PasswordError && (
                                                <small className="text-danger">
                                                    Use at least 7 characters.
                                                </small>
                                            )}
                                        </div>

                                        {errorMsg && (
                                            <p className="text-danger text-center mt-4">
                                                <b>{errorMsg}</b>
                                            </p>
                                        )}

                                        <button
                                            type="button"
                                            onClick={sendVerificationCode}
                                            className="col-12 btn btn-dark big-btn mt-4"
                                            disabled={loading}
                                        >
                                            {loading ? "Loading..." : "Continue"}
                                        </button>

                                        <div className="google-auth-wrapper mt-4">
                                            <div className="auth-divider">
                                                <span>or</span>
                                            </div>

                                            <button
                                                type="button"
                                                className="google-auth-btn"
                                                onClick={() => googleRegister()}
                                            >
                                                <img
                                                    src={glogo}
                                                    alt="Google"
                                                    className="google-real-icon"
                                                />
                                                <span>Continue with Google</span>
                                            </button>
                                        </div>

                                        <div className="mt-4 text-center">
                                            <p className="f85">
                                                Already have an account?{" "}
                                                <Link to="/seller/login">
                                                    Sign in
                                                </Link>
                                            </p>
                                        </div>
                                    </>
                                )}

                                {ShowEmail && (
                                    <div className="mt-4 border p-4 br-10">
                                        <label className="form-label">
                                            Email Code
                                        </label>

                                        <input
                                            type="number"
                                            name="email_code"
                                            value={registerFormData.email_code}
                                            onChange={inputHandler}
                                            className="form-control"
                                        />

                                        <div
                                            onClick={sendVerificationCode}
                                            className="mt-3 text-blue pointer"
                                        >
                                            Resend
                                        </div>

                                        <button
                                            type="button"
                                            onClick={verifyCode}
                                            className="col-12 btn btn-dark mt-3"
                                        >
                                            Complete
                                        </button>
                                    </div>
                                )}

                                {ShowSuccessPage && (
                                    <div className="text-center mt-4">
                                        <CheckCircle size={100} />

                                        <h2 className="mt-3">
                                            <b>Success</b>
                                        </h2>

                                        <p>
                                            Your account has been successfully created.
                                        </p>

                                        <Link
                                            to="/seller/login"
                                            className="btn btn-success"
                                        >
                                            Proceed to Sign in
                                        </Link>
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default SellerRegister;